import React, { memo } from "react";
import styles from "../ABheader.scss";
import { faHeaderNavClick } from "../services/ABheader.analytics";
const { top_head_sectioin, container, top_nav_item, active } = styles;

export default function TopHeaderComponent({ top_header, flowName }) {
  return (
    <>
      <div className={top_head_sectioin}>
        <div className={container}>
          <ul className={top_nav_item}>
            <TopHeaderLinks top_header={top_header} flowName={flowName} />
          </ul>
        </div>
      </div>
    </>
  );
}

const TopHeaderLinks = memo(({ top_header, flowName }) => {
  const setTopData = top_header.map((topLinkData, index) => (
    <li key={index} className={topLinkData.isCurrent === true ? active : ""}>
      <a href={topLinkData.linkUrl} onClick={() => faHeaderNavClick({ flowName: flowName, segment: topLinkData.linkText })}>
        {topLinkData.linkText}
      </a>
    </li>
  ));
  return setTopData;
});
